module.exports = __webpack_public_path__ + "static/img/Business-investment-immigration-1.07e7b1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/Business-investment-immigration-1.jpg
// module id = Qfa6
// module chunks = 1